/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { DocumentListItemFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { HStack } from "@panda/jsx";
import { CosmosLink, EdsIcon, CosmosText } from "@components/elements/atoms";
import { Key } from "react";
import { useLocale } from "@epic-mw/i18n";

const styles = css({
	paddingBlock: "eds.dimension.16",
	paddingInline: "eds.dimension.20",
	w: "full",
	background: "eds.palette.transparent.light.005",
	border: "1px solid",
	borderColor: "eds.palette.transparent.light.005",
	_hover: {
		background: "eds.palette.transparent.light.010",
	},
});

export interface DocumentListItemProps extends DocumentListItemFragment {
	key?: Key | null;
}

export const DocumentListItem = ({
	title,
	icon,
	href,
	iconGradient,
}: DocumentListItemProps): React.JSX.Element | null => {
	const locale = useLocale();

	if (!title || !href) {
		return null;
	}

	//replace :locale in the href
	const finalHref = href.replace(/:locale/gi, locale);

	return (
		<CosmosLink href={finalHref || ""} className={cx("document-list-item", styles)}>
			<HStack justifyContent="space-between">
				<HStack gap="eds.dimension.16">
					<EdsIcon icon={icon || "FileLines"} gradient={iconGradient || undefined} />
					<CosmosText variant="paragraphMD">{title}</CosmosText>
				</HStack>
				<div
					className={css({
						background: "eds.border.subtle",
						borderRadius: "eds.borderRadius.full",
						padding: "eds.dimension.4",
					})}
				>
					<EdsIcon icon="ChevronRight" size="xs" />
				</div>
			</HStack>
		</CosmosLink>
	);
};
